export const SkillsSection = () => {
    return (
        <div id="skills" class="Section SkillsSection">
            <div class="SectionTitle"><h2>Skills 👨‍💻</h2></div>
            <div class="CardGrid SkillsGrid">
                <Card title="iOS Development" description="I am experienced in developing apps for iOS devices (iPhone, iPad) using Swift and Xcode. I have built productivity apps, games, and everything in between." langsAndTools="Swift, Xcode"/>
                <Card title="Web development" description="I build, publish and maintain websites using HTML, CSS and JavaScript with React - such as this website." langsAndTools="Languages and tools: HTML, CSS, JavaScript, TypeScript, React"/>
                <Card title="Back-end" description="Through building iOS apps I have gained experience in back-end programming. I have implemented database functionality with a wide range of functionalities, allowing for real-time updates and managing large quantities of data efficiently." langsAndTools="Languages and tools: Python, C++, JavaScript"/>
                <Card title="Competitive programming" description="I have competed on a regular basis in competitive programing contests for over 2 years. These problems have taught me to choose appropriate data structures, and enable me to work efficiently with large datasets." langsAndTools="Languages and tools: Python, C++"/>
                <Card title="Cybersecurity" description="I am experienced with a wide range of concepts within cybersecurity, such as cryptography, SQL injections, cross-site scripting, steganography and more." langsAndTools="Languages and tools: Python, Bash, Linux (Kali), VBA"/>
                <button onClick={() => { window.open("./#/projects#start"); }} class="Card LearnMore">
                    <h3>Learn more</h3>
                    <p>Want to learn more? Click here to view the projects I have worked on!</p>
                </button>
            </div>
            <p><br></br></p>
        </div>
    )
}

const Card = (props) => {
    return (
        <div class="Card" style={props.style}>
            <h3>{props.title}</h3>
            <p>{props.description}</p>
            <h5>{props.langsAndTools}</h5>
        </div>
    )
}